import ResizeController from '../../assets/js/controllers/resize';

import Platform from '../../assets/js/constants/platform';
import ProgressEvent from '../../bits/progress/progress-event';

import { validateParamBoolean } from '../../assets/js/helpers';

export default class ScrollTracking {

	static selector = '[data-scroll-tracking]';

	// class variables

	attributes = {
		// configuration
		mobileEnabled: 'data-scroll-tracking-mobile',
		desktopEnabled: 'data-scroll-tracking-desktop'
	};

	config = {
		isMobileEnabled: true,
		isDesktopEnabled: true,
	};

	controllers = {
		resize: null
	};

	coords = {
		scrollItem: {
			width: 0
		},
		scrollItemsMask: {
			scrollWidth: 0,
			clientWidth: 0
		}
	};

	el = {};

	flags = {
		isEnabled: false
	};

	selectors = {
		// elements
		scrollItem: '[data-scroll-tracking-item]',
		scrollItemsMask: '[data-scroll-tracking-items-mask]',
		listeners: '[data-scroll-tracking-listener]',
	};

	states = {
		platform: null
	};

	// constructor

	constructor(container) {
		this.el = {
			container,

			// singles
			scrollItem: container.querySelector(this.selectors.scrollItem),
			scrollItemsMask: container.querySelector(this.selectors.scrollItemsMask),

			// multiples
			listeners: container.querySelectorAll(this.selectors.listeners)
		};

		this.config.isMobileEnabled = validateParamBoolean(this.el.container, this.attributes.mobileEnabled, true, true);
		this.config.isDesktopEnabled = validateParamBoolean(this.el.container, this.attributes.desktopEnabled, false, true);

		this.initialize();
	}

	// init

	initialize() {
		this.#addEventListeners();
		this.measureResize();
		this.adjustResize();
	}

	// event listeners

	#addEventListeners = () => {
		this.el.scrollItemsMask.addEventListener('scroll', this.#onScroll);
		this.controllers.resize = ResizeController.set({
			update: this.#onResizeUpdate,
			render: this.#onResizeRender
		});
	}

	#removeEventListeners = () => {
		this.el.scrollItemsMask.removeEventListener('scroll', this.#onScroll);
		ResizeController.clear(this.controllers.resize);
	}

	// listener methods

	#onScroll = () => {
		this.measureScroll();
		this.adjustScroll();
	};

	// controller methods

	#onResizeUpdate = () => this.measureResize();
	#onResizeRender = () => {
		this.adjustResize();
	}

	//

	measureResize() {
		let willRender = ResizeController.isPlatformChange;

		this.states.platform = ResizeController.platform;

		this.coords.scrollItem.width = this.el.scrollItem.scrollWidth;
		this.coords.scrollItemsMask.scrollWidth = this.el.scrollItemsMask.scrollWidth;
		this.coords.scrollItemsMask.clientWidth = this.el.scrollItemsMask.clientWidth;

		if (this.states.platform === Platform.DESKTOP) {
			if (this.config.isDesktopEnabled) {
				if (!this.flags.isEnabled) {
					this.enable();
					willRender = true;
				}
			} else if (this.flags.isEnabled) {
				this.disable();
				willRender = true;
			}
		} else {
			if (this.config.isMobileEnabled) {
				if (!this.flags.isEnabled) {
					this.enable();
					willRender = true;
				}
			} else if (this.flags.isEnabled) {
				this.disable();
				willRender = true;
			}
		}

		return willRender;
	}

	adjustResize() {
		this.tickScroll();
	}

	//

	tickScroll() {
		this.measureScroll();
		this.adjustScroll();
	}

	measureScroll() {
		const { scrollLeft } = this.el.scrollItemsMask;
		this.states.scrollRatio = scrollLeft / (this.coords.scrollItemsMask.scrollWidth - this.coords.scrollItemsMask.clientWidth);
	}

	adjustScroll() {
		if (this.flags.isEnabled && !isNaN(this.states.scrollRatio)) {
			for (let i = 0; i < this.el.listeners.length; i++) {
				const $eventTarget = this.el.listeners[i];
				$eventTarget.dispatchEvent(new CustomEvent(ProgressEvent.ADJUST, { detail: { ratio: this.states.scrollRatio } }));
			}
		}
	}

	//

	enable() {
		this.flags.isEnabled = true;
	}

	disable() {
		this.flags.isEnabled = false;
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
